export class ColumnDefinition {
  name: string;
  title: string;
  groupingHeaderName?: string;
  visible: boolean;
  sortable: boolean = true;
  translatable: boolean;
  wrap: boolean;
  mutator?: (data: any, params?: any) => any;
  mutatorParams?: any;
  formatter?: (value?: any, params?: any) => any;
  formatterParams?: any;
  printable: boolean;
  style?: Record<string, string>;
  /** Szerokość startowa kolumny w px, gdy użytkownik nie ma jeszcze własnej. Bez niej idzie DEFAULT_COLUMN_WIDTH. */
  defaultWidth?: number;
  /**
   * Kolumna przypięta - jak "options": zawsze widoczna, zawsze na początku (zaraz za "options"),
   * bez przenoszenia, bez zmiany szerokości (trzyma `defaultWidth`) i bez wpisu w ustawieniach
   * kolumn, więc nie ma jej w liście widoczności/kolejności.
   */
  locked?: boolean;
  /** Nazwa ikony svg pokazywanej w nagłówku zamiast tytułu (tytuł zostaje jako tooltip). */
  headerIcon?: string;
  /**
   * Porządek surowych wartości kolumny przy sortowaniu - od "najmniejszej" do "największej". Dla kolumn
   * ze skalą stanów, której alfabet nie odtwarza. Tylko przy sortowaniu w pamięci (patrz sortData).
   */
  sortValues?: string[];
  formatExt?: (data?: any) => any;
  localPrintFormat?: (data: any) => any;
  /** Zawartość komórki ukryta dla konkretnego wiersza - sama kolumna (nagłówek, szerokość) zostaje. */
  cellHidden?: (data: any) => boolean;

  static numberTypeFormatter = (value?: any, params?: any): any => {
    if (value != null) {
      return ColumnDefinition.typeFormatter(+value, params);
    }
  };

  static typeFormatter = (value?: any, params?: any): any => {
    if (value != null) {
      if (params != null) {
        if (Array.isArray(value)) {
          const result = [];
          value.forEach(input => {
            const foundValue = params[input];
            if (foundValue) result.push(foundValue);
            else result.push(input);
          });
          return result;
        } else {
          const foundValue = params[value];
          if (foundValue)
            return foundValue;
        }
      }
    }
    return value;
  };

  static formatDecimal(value: any, format: string): any {
    const splitted = format.split('.');
    let decimalCount = 0;
    if (splitted.length == 2) {
      decimalCount = splitted[1].length;
    }

    if (Array.isArray(value)) {
      const formatted = value.map(element => {
        if (element != null && !isNaN(+element))
          return (+element).toFixed(decimalCount);
        else
          return null;

      });
      return `[${formatted.join(', ')}]`;
    } else {
      return (+value).toFixed(decimalCount);
    }
  }

  mutate(data: any, fieldName: string): void {
    if (this.mutator) {
      data[fieldName] = this.mutator(data, this.mutatorParams);
    }
  }

  format(value?: any): any {
    if (this.formatter)
      return this.formatter(value, this.formatterParams);
    else if (this.formatterParams?.format) {
      if (value != null) {
        const formatted = ColumnDefinition.formatDecimal(value, this.formatterParams.format);
        if (formatted != null)
          return formatted;
      }
    } else if (Array.isArray(value))
      return value.join(', ');
    return value;
  }

}
